<sales-loader [@fadeInOut] *ngIf="loading$ | async"></sales-loader>
<dgx-ui-wl-header
  [navigationLinks]="headerNavigationLinks"
  clientLogoPath="assets/images/hoover-logo.png"
></dgx-ui-wl-header>
<main>
  <sales-welcome-back-message
    *ngIf="isCheckoutPage"
    [personalDetails]="userProfileFacade.personalDetails$ | async"
  ></sales-welcome-back-message>
  <ui-progress-tracker-route-based
    [steps]="progressSteps$ | async"
    [currentRoute]="currentRoute"
  ></ui-progress-tracker-route-based>
  <router-outlet></router-outlet>
</main>
<dgx-ui-wl-footer
  [protectLinks]="footerNavigationLinks.protectLinks"
  [usefulLinks]="footerNavigationLinks.usefulLinks"
  [legalLinks]="footerNavigationLinks.legalLinks"
  [moreLinks]="footerNavigationLinks.socialLinks"
  [copyrightOwner]="'Domestic & General Group Limited'"
>
  <p>
    Insurance policies are provided by Domestic & General Insurance PLC.
    Domestic & General Insurance PLC is an insurance undertaking, not an
    intermediary. We are the underwriter of the insurance policies and do not
    provide a personal recommendation or advice. Domestic & General Insurance
    PLC is authorised by the Prudential Regulation Authority and regulated by
    the Financial Conduct Authority and the Prudential Regulation Authority
    (Financial Services Register Number 202111). Our address and details of our
    authorisation can be checked on the
    <a href="https://register.fca.org.uk/" target="_blank" rel="noopener"
      >FCA website</a
    >.
  </p>
</dgx-ui-wl-footer>
